import { buildProjectPageUrl } from 'routes/builders'

/**
 * Build a feedback page URL with optional filters and post UUID.
 *
 * @param projectId - The project UUID
 * @param filterHash - Optional filter hash for applying filters
 * @param postUuid - Optional post UUID for linking to specific verbatim
 * @param conversationUuid - Optional conversation UUID for tracking source conversation
 * @returns Full URL to feedback page with query parameters
 */
export const buildFeedbackUrl = (
  projectId: string,
  filterHash?: string | null,
  postUuid?: string | null,
  conversationUuid?: string | null,
): string => {
  const basePath = filterHash
    ? buildProjectPageUrl(projectId, 'feedback', filterHash)
    : `/project/${projectId}/feedback`

  const params = new URLSearchParams()

  if (postUuid) {
    params.append('post', postUuid)
  }

  if (conversationUuid) {
    params.append('cuid', conversationUuid)
  }

  const baseUrl = `${window.location.origin}${basePath}`
  return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl
}
